import { render, staticRenderFns } from "./navSubtitle.vue?vue&type=template&id=44f2c4e2&"
import script from "./navSubtitle.vue?vue&type=script&lang=js&"
export * from "./navSubtitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports